import * as request from './utils/requester';

export const AUTH_TOKEN_KEY = 'authToken';

export const register = (email, password) =>
    request.post('/auth/register', { email, password });

export const login = (email, password) =>
    request.post('/auth/login', { email, password });

export const me = () => request.get('/auth/me');

export const logout = () => request.post('/auth/logout', {});

export const saveToken = (token) => {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
};

export const clearToken = () => {
    localStorage.removeItem(AUTH_TOKEN_KEY);
};

export const getToken = () => localStorage.getItem(AUTH_TOKEN_KEY);
